<template>
  <VView class="contest-submit" :header="$t('contestSubmit.header')">
    <VButton @click="submit()">{{ $t('contestSubmit.submit') }}</VButton>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import VView from '@/components/VView.vue';
import VButton from '@/components/VButton.vue';

export default {
  name: 'ContestSubmit',

  components: {
    VView,
    VButton,
  },

  computed: {
    ...mapState({
      payload: state => ({
        ...state.personal,
        ...state.legal,
        answer: state.answer,
        attachment: state.attachment,
        score: state.score,
      }),
    }),
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    async submit() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$bricodes.createEntry(this.payload);
      } catch (error) {
        console.log(error);
      }

      this.$router.push('/contest/end');
    },
  },
};
</script>

<style lang="scss">
.contest-submit {}
</style>
